export const useAnchorScrollManager = (anchors: UseAnchors) => {
  const scrolled = ref<boolean>(false);

  const scrollToAnchor = (anchor, behavior: ScrollBehavior = 'smooth') => {
    const { position } = anchor;
    const { offset } = anchors;
    const scrollY = position - offset.value; // 10 is arbitrary
    window.scrollTo({
      top: scrollY,
      behavior,
    });
  };

  const debouncedScroll = useDebounceFn((anchor) => {
    scrollToAnchor(anchor, 'auto');
  }, 1);

  onMounted(() => {
    const anchor = anchors.getAnchorFromRoute();
    if (!scrolled.value && anchor) {
      debouncedScroll(anchor);
    }
  });

  return {
    scrollToAnchor,
  };
};
